import { render, staticRenderFns } from "./TeacherLeaveMyLeave.vue?vue&type=template&id=64ced458&scoped=true&"
import script from "./TeacherLeaveMyLeave.vue?vue&type=script&lang=js&"
export * from "./TeacherLeaveMyLeave.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLeaveMyLeave.vue?vue&type=style&index=0&id=64ced458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ced458",
  null
  
)

export default component.exports